<template>
  <div class="GroupingDialog">
    <el-dialog
      title="更换分组"
      @open="openHandler"
      :visible.sync="open"
      :close-on-click-modal="true"
      width="550px"
    >
    <div class="GroupingDialog-box">
      <el-form ref="formRef" :model="form" :rules="rules" :inline="true">
        <el-form-item label="选择分组" prop="newGroupId" >
          <el-select v-model="form.newGroupId" placeholder="请选择分组">
            <el-option
                v-for="item in groupList"
                :key="item.groupId"
                :label="item.name"
                :value="item.groupId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-box">
      <el-button @click="confirm" class="btn" type="primary">确认</el-button>
      <el-button @click="cancel" class="btn">取消</el-button>
    </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "GroupingDialog",
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    docId: {
      type: String,
      default: () => ""
    },
    oldGroupId: {
      type: String,
      default: () => ""
    },
    ids: {
      type: String,
      default: () => ""
    },
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  data() {
    return {
      form:{
        newGroupId:'',
      },
      rules: {
        newGroupId: [
          { required: true, message: "请选择分组", trigger: "change" },
        ],
      },
      groupList: [],
    };
  },
  created() {

  },
  methods:{
    async getGroupList() {
      try {
        const res = await this.$get('group/list', {
          docId: this.$store.state.doctor_id,
        });
        if (!res) return false;
        const { data } = res;
        console.log(data,'oo....',this.oldGroupId,);

        this.groupList = (data || []).filter(item => item.groupId !== this.oldGroupId && (item.isLeader === 1 || this.$store.state.roleName == '超级管理员' || this.$store.state.roleName == '管理员'));
      }catch(e){
        console.error(e);
      }
    },
    async openHandler() {
      await this.getGroupList();
    },
    confirm(){
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false;
        await this.replaceApi();
      });
    },
    async replaceApi() {
      try {
        const res = await this.$post("group/batchTransferGroup",{
          ...this.form,
          docId: this.docId,
          oldGroupId: this.oldGroupId,
          ids: this.ids,
        })
        if (!res) return false;
        this.$message.success('分组成功');
        this.cancel();
        this.$emit("updateList");
      }catch (e) {
        console.error(e);
      }
    },
    cancel(){
      this.$refs.formRef.resetFields();
      this.open = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.GroupingDialog {
  .GroupingDialog-box{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn-box{
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #EBECF0;
    padding-top: 20px;
    gap: 20px;
    .btn{
      width: 90px;
      height: 36px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-content: center;
    }
  }
}
::v-deep .el-dialog__header {
    background-color: #1a7cf2;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      font-size: 20px;
      .el-dialog__close {
        color: #fff;
      }
    }
  }
</style>
